// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:16:18

export default {
  "id": "ice-skating-ballerina",
  "slug": "ice-skating-ballerina",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/cdfe8e38787e49e7a654f9175714d6d0-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/cdfe8e38787e49e7a654f9175714d6d0/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Ice Skating Ballerina",
      "description": "Dive into a winter wonderland and help Ellie and Ben prep for an exciting ice skating competition. Customize skates, curate dazzling outfits, and make a style statement on the ice. Browse through a vast collection of colorful ballerina and glam outfits, chic accessories, and shoes. Glide, twirl, and experience the fun-filled, fashion-centric icy adventure with this engaging dress-up game for girls.",
      "instructions": "Use your mouse to play this game on a desktop, tap to play on mobile devices. ",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "couple",
        "cutedressup",
        "decoration",
        "fashion",
        "winter"
      ]
    },
    "zh-CN": {
      "title": "滑冰芭蕾舞者",
      "description": "沉浸在一个冬日仙境中，帮助艾莉和本为一场激动人心的滑冰比赛做准备。定制冰鞋，挑选令人眼花缭乱的装扮，在冰上展现你的风格。浏览丰富的彩色芭蕾舞者和华丽装扮，时尚配饰和鞋子。滑行、旋转，体验这个充满乐趣、以时尚为主题的冰上冒险，这是一款专为女孩设计的有趣装扮游戏。",
      "instructions": "使用鼠标在桌面版上玩游戏，在移动设备上轻触屏幕进行游戏。",
      "genres": [
        "装扮"
      ],
      "tags": [
        "情侣",
        "可爱装扮",
        "装饰",
        "时尚",
        "冬季"
      ]
    },
    "zh-TW": {
      "title": "溜冰芭蕾舞者",
      "description": "跳進冬日的奇蹟世界，幫助 Ellie 和 Ben 為精彩的滑冰比賽作準備。自訂滑冰鞋，挑選耀眼的服裝，在冰上展現風格。瀏覽多樣的彩色芭蕾舞者和時尚服裝，時尚配件和鞋履。滑行、旋轉，體驗這款引人入勝的打扮遊戲為女孩帶來的充滿歡樂的時尚冰上冒險。",
      "instructions": "使用滑鼠在桌面上玩這款遊戲，在行動裝置上點擊即可玩遊戲。",
      "genres": [
        "裝飾服裝"
      ],
      "tags": [
        "夫妻",
        "可愛装扮",
        "裝飾",
        "時尚",
        "冬季"
      ]
    },
    "zh-HK": {
      "title": "溜冰芭蕾舞者",
      "description": "投入冬日仙境，幫助 Ellie 和 Ben 為一場刺激的溜冰比賽作準備。自訂溜冰鞋，精選閃耀的服裝，在冰上展現個人風格。瀏覽色彩繽紛的芭蕾舞者和時尚服裝，時髦的首飾和鞋子。滑行、旋轉，與這款吸引人的女孩裝扮遊戲一起享受充滿歡樂和時尚的冰上冒險。",
      "instructions": "使用滑鼠於桌上型電腦遊戲，於行動裝置上則點擊以遊玩。",
      "genres": [
        "打扮"
      ],
      "tags": [
        "情侶",
        "可愛裝飾",
        "裝飾",
        "時尚",
        "冬季"
      ]
    },
    "ja": {
      "title": "アイススケートバレリーナ",
      "description": "冬の幻想の世界に潜り込み、エリーとベンがスケート競技会に準備する手助けをしましょう。スケートをカスタマイズし、輝くユニフォームを編成し、アイス上でスタイルを打ち出しましょう。カラフルなバレリーナやグラミー風の服、スタイリッシュなアクセサリー、そして靴の広大なコレクションを見て回りましょう。滑走、回転し、この魅力的なドレスアップゲームでファッションに焦点を当てた楽しいアイスの冒険を体験しましょう。",
      "instructions": "デスクトップではマウスを使用してこのゲームをプレイし、モバイルデバイスではタップでプレイしてください。",
      "genres": [
        "ドレスアップ"
      ],
      "tags": [
        "カップル",
        "可愛いドレスアップ",
        "装飾",
        "ファッション",
        "冬"
      ]
    },
    "ko": {
      "title": "아이스 스케이팅 발레리나",
      "description": "겨울의 신비한 세상에 뛰어들어 엘리와 벤이 흥미진진한 아이스스케이팅 경쟁을 준비하는 도움을 주세요. 스케이트를 맞춤화하고 빛나는 의상을 커리어, 빙상에서 스타일을 남기세요. 다양한 색상의 발레리나와 긴 의상, 시크한 액세서리, 신발을 브라우징하세요. 이 흥미진진한 드레스업 게임을 통해 즐거운, 패션 중심의 빙상 모험을 경험하세요.",
      "instructions": "마우스를 사용하여 데스크톱에서 게임을 플레이하세요. 모바일 기기에서는 탭하여 플레이하세요.",
      "genres": [
        "드레스업"
      ],
      "tags": [
        "커플",
        "귀여운 드레스업",
        "장식",
        "패션",
        "겨울"
      ]
    },
    "fr": {
      "title": "Patinage artistique ballerine",
      "description": "Plongez dans un monde enchanté d'hiver et aidez Ellie et Ben à se préparer pour une compétition de patinage à glace passionnante. Personnalisez les patins, assemblez des tenues éblouissantes et faites une déclaration de style sur la glace. Parcourez une vaste collection de tenues de ballerine colorées et de tenues glamour, d'accessoires chics et de chaussures. Glissez, tournez et vivez l'aventure festive et centrée sur la mode sur la glace avec ce jeu de déguisement captivant pour les filles.",
      "instructions": "Utilisez votre souris pour jouer à ce jeu sur un ordinateur de bureau, appuyez pour jouer sur les appareils mobiles.",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "couple",
        "déguisement mignon",
        "décoration",
        "mode",
        "hiver"
      ]
    }
  }
};
